import {ModuleWithProviders, NgModule} from '@angular/core';
import {AppOptions, ConfigureService} from './configure.service';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';



@NgModule({
  declarations: [],
  exports: [],
  imports: [],
  providers: [],
  bootstrap: []
})
export class ConfigureModule {
  static forRoot(options: AppOptions): ModuleWithProviders<ConfigureModule> {
    return {
      ngModule: ConfigureModule,
      providers: [
        {
          provide: ConfigureService, useFactory: () => new ConfigureService(options)
        },
        {
          provide: 'externalUrlRedirectResolver',
          useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
          {
            const extUrl = state.url.replace(/(admin|app)/, '$1/#!');
            window.location.href = extUrl;
          }
        }
      ]
  }
    ;
  }
}


